import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useCurrentEvent } from './eventContext'

/**
 * Keeps a poker-only (POKER) event off golf-oriented routes (the golf summary).
 * Poker is operational — its home is the Poker tab — so a stray link to
 * `/summary` bounces there instead of rendering golf boards that have no course.
 */
const PokerModeGuard = ({ children }: { children: ReactNode }) => {
  const event = useCurrentEvent()
  if (event.mode === 'POKER') {
    return <Navigate to={`/events/${event.id}/poker`} replace />
  }
  return children
}

export default PokerModeGuard
